import type { AppDefinition } from '../../types/apps';

export const UpgradeAppDefinition: AppDefinition = {
  appId: 'upgrade',
  name: 'Upgrade',
  version: '1.0.0',
  description: 'Upgrade your River plan.',

  entityTypes: [],
  requiresEntity: false,
  requiresProps: false,

  component: 'upgrade',

  icon: {
    type: 'phosphor',
    phosphorIcon: 'CrownSimple',
    phosphorWeight: 'duotone',
    color: '#f59e0b',
    metadata: {
      source: 'app',
      appId: 'upgrade',
      isAppIcon: true,
    },
  },

  defaultWindowSize: { width: 780, height: 680 },

  category: 'system',
  isCore: true,
  isSystem: true,
  hidden: true,
};

export default UpgradeAppDefinition;
